import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "loading-spinner"
};
const _hoisted_2 = {
  class: "d-flex justify-end"
};
const _hoisted_3 = {
  class: "d-flex justify-end"
};
import { onMounted, reactive, computed } from "vue";
import LlSecondaryButton from "@/components/LlSecondaryButton.vue";
import { storeToRefs } from 'pinia';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useUpgradeSubscriptionStore } from "./upgradeSubscriptionStore.js";
import EventTracker from "../../../services/eventTracker";
import { isValidSingleEmail } from "../../../services/utils";

// Get features from the MeStore

export default {
  __name: 'UpgradeDialog',
  props: {
    alerts: {
      type: Object,
      required: false
    },
    reportState: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: false
    },
    tracking: {
      type: Object,
      required: false
    },
    state: {
      type: Object,
      required: true
    },
    stateParams: {
      type: Object,
      required: true
    },
    routeService: {
      type: Object,
      required: false
    }
  },
  emits: ["closeUpgradeDialog"],
  setup(__props, {
    emit: __emit
  }) {
    const meStore = useMeStore();
    const {
      features
    } = storeToRefs(meStore);
    const props = __props;
    const upgradeSubscriptionStore = useUpgradeSubscriptionStore();
    upgradeSubscriptionStore.alerts = props.alerts;
    const emit = __emit;
    const upgradeState = reactive({
      dialog: true,
      loading: false,
      disabledBillingEmail: true,
      proProductPlans: [],
      paymentDescription: "",
      subscriptions: {
        email: "",
        plan: {
          id: "",
          label: "",
          periodEnd: "",
          seats: "",
          price: "",
          billingEmail: "",
          payment: "",
          interval: ""
        }
      }
    });
    onMounted(async () => {
      try {
        upgradeState.loading = true;
        await upgradeSubscriptionStore.getSubscriptions();
        await upgradeSubscriptionStore.listSubscriptionProducts();
        upgradeState.subscriptions = {
          ...upgradeSubscriptionStore.subscriptions,
          paymentDescription: upgradeSubscriptionStore.subscriptions.bank?.description || upgradeSubscriptionStore.subscriptions.card?.description
        };
        upgradeState.proProductPlans = upgradeSubscriptionStore.getProPlansFromPlanInterval(upgradeSubscriptionStore.subscriptions?.plan?.interval);
        upgradeState.loading = false;
      } catch (error) {
        props.alerts?.error(error.message || error.response.data.message);
        upgradeState.loading = false;
      }
    });
    const confirmUpgrade = async () => {
      if (!validEmail.value) {
        props.alerts?.error("Please enter a valid email");
        return;
      } else {
        upgradeState.loading = true;
        const response = await upgradeSubscriptionStore.updateSubscriptions({
          planId: upgradeState.proProductPlans?.plans[0]?.id
        });
        if (response && response.product && (response.product?.leanlawProductId === "pro" || response.product?.leanlawProductId === "legacy")) {
          if (props.reportState) {
            trackEvent("Changed to LeanLaw Pro", "Confirmed");
          }
          emit("closeUpgradeDialog", response);
        } else {
          emit("closeUpgradeDialog", false);
        }
        upgradeState.dialog = false;
        upgradeState.loading = false;
      }
    };
    const closeDialog = () => {
      upgradeState.dialog = false;
      emit("closeUpgradeDialog", true);
    };
    const changeBillingEmail = async value => {
      if (!validEmail.value) {
        props.alerts?.error("Please enter a valid email");
        return;
      }
      upgradeState.disabledBillingEmail = !upgradeState.disabledBillingEmail;
      if (value === "update") {
        try {
          await upgradeSubscriptionStore.updateSubscriptions({
            email: upgradeState.subscriptions.email
          });
          props.alerts?.success("Billing email updated successfully");
          trackEvent("Billing Email", "Changed");
          upgradeState.disabledBillingEmail = true;
        } catch (error) {
          props.alerts.error(error.message || error.response.data.message);
        }
      }
    };
    const changePaymentMethod = async value => {
      if (upgradeState.subscriptions.bank) {
        await upgradeSubscriptionStore.bank();
      } else if (upgradeState.subscriptions.card) {
        await upgradeSubscriptionStore.card();
      } else {
        props.alerts?.error("Please add a payment method");
        return;
      }
    };
    const formattedRenewalDate = computed(() => {
      if (!upgradeState.subscriptions?.plan?.periodEnd) {
        return "";
      }
      const date = new Date(upgradeState.subscriptions?.plan?.periodEnd);
      return date.toISOString().split("T")[0].replace(/-/g, "/");
    });
    const trackEvent = (category, action) => {
      EventTracker.trackEvent(props.tracking, category, action, {
        createdAt: new Date().toLocaleDateString("en-US"),
        email: props.reportState.me?.email,
        name: props.reportState.me?.name,
        role: props.reportState.me?.role
      });
    };
    const validEmail = computed(() => {
      const billingEmail = upgradeState.subscriptions.email;
      if (billingEmail) {
        return isValidSingleEmail(billingEmail);
      }
      return false;
    });
    return (_ctx, _cache) => {
      const _component_v_progress_circular = _resolveComponent("v-progress-circular");
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_text_field = _resolveComponent("v-text-field");
      const _component_v_col = _resolveComponent("v-col");
      const _component_v_row = _resolveComponent("v-row");
      const _component_v_container = _resolveComponent("v-container");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_spacer = _resolveComponent("v-spacer");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_dialog = _resolveComponent("v-dialog");
      const _component_v_main = _resolveComponent("v-main");
      const _component_v_app = _resolveComponent("v-app");
      return _openBlock(), _createBlock(_component_v_app, null, {
        default: _withCtx(() => [_createVNode(_component_v_main, null, {
          default: _withCtx(() => [_createVNode(_component_v_container, null, {
            default: _withCtx(() => [_createVNode(_component_v_dialog, {
              modelValue: upgradeState.dialog,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => upgradeState.dialog = $event),
              persistent: "",
              "max-width": "900px"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_card, null, {
                default: _withCtx(() => [upgradeState.loading ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_v_progress_circular, {
                  style: {
                    "min-height": "300px"
                  },
                  size: 70,
                  width: 7,
                  color: "orange",
                  indeterminate: ""
                })])) : _createCommentVNode("", true), _createVNode(_component_v_card_title, {
                  class: "headline"
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("Confirm your upgrade to ", -1), _createElementVNode("span", {
                    class: "text-dark-yellow"
                  }, " LeanLaw Pro", -1)]))]),
                  _: 1
                }), _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [_createVNode(_component_v_container, null, {
                    default: _withCtx(() => [_createVNode(_component_v_row, null, {
                      default: _withCtx(() => [_createVNode(_component_v_col, {
                        cols: "6"
                      }, {
                        default: _withCtx(() => [_cache[7] || (_cache[7] = _createElementVNode("div", {
                          class: "text-subtitle-1 text-medium-emphasis"
                        }, "Plan", -1)), _createVNode(_component_v_text_field, {
                          value: upgradeState.subscriptions.plan?.label,
                          variant: "solo-filled",
                          color: "primary",
                          disabled: true,
                          class: "tw green-input"
                        }, null, 8, ["value"])]),
                        _: 1
                      }), _createVNode(_component_v_col, {
                        cols: "6"
                      }, {
                        default: _withCtx(() => [_cache[8] || (_cache[8] = _createElementVNode("div", {
                          class: "text-subtitle-1 text-medium-emphasis"
                        }, " Renewal date ", -1)), _createVNode(_component_v_text_field, {
                          value: formattedRenewalDate.value,
                          variant: "solo-filled",
                          color: "primary",
                          disabled: true,
                          class: "tw green-input"
                        }, null, 8, ["value"])]),
                        _: 1
                      }), _createVNode(_component_v_col, {
                        cols: "6"
                      }, {
                        default: _withCtx(() => [_cache[9] || (_cache[9] = _createElementVNode("div", {
                          class: "text-subtitle-1 text-medium-emphasis"
                        }, " Seats (Users) ", -1)), _createVNode(_component_v_text_field, {
                          value: upgradeState.subscriptions.plan?.seats,
                          variant: "solo-filled",
                          color: "primary",
                          disabled: true,
                          class: "tw green-input"
                        }, null, 8, ["value"])]),
                        _: 1
                      }), _createVNode(_component_v_col, {
                        cols: "6"
                      }, {
                        default: _withCtx(() => [_cache[10] || (_cache[10] = _createElementVNode("div", {
                          class: "text-subtitle-1 text-medium-emphasis"
                        }, " Billing Email ", -1)), _createVNode(_component_v_text_field, {
                          modelValue: upgradeState.subscriptions.email,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => upgradeState.subscriptions.email = $event),
                          variant: "solo-filled",
                          color: "primary",
                          disabled: upgradeState.disabledBillingEmail,
                          class: "tw green-input"
                        }, null, 8, ["modelValue", "disabled"]), _createElementVNode("div", _hoisted_2, [upgradeState.disabledBillingEmail ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "change-text ml-2",
                          onClick: _cache[1] || (_cache[1] = $event => changeBillingEmail('change'))
                        }, "Change")) : _createCommentVNode("", true), !upgradeState.disabledBillingEmail ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: "change-text ml-2",
                          onClick: _cache[2] || (_cache[2] = $event => changeBillingEmail('update'))
                        }, " Update")) : _createCommentVNode("", true)])]),
                        _: 1
                      }), !_unref(features)?.customPricing ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 0,
                        cols: "6"
                      }, {
                        default: _withCtx(() => [_cache[11] || (_cache[11] = _createElementVNode("div", {
                          class: "text-subtitle-1 text-medium-emphasis"
                        }, " Price ", -1)), _createVNode(_component_v_text_field, {
                          value: upgradeState.subscriptions.plan?.price ? `$${upgradeState.subscriptions?.plan?.price}  per user per month` : '',
                          variant: "solo-filled",
                          color: "primary",
                          disabled: true,
                          class: "tw green-input",
                          outlined: ""
                        }, null, 8, ["value"])]),
                        _: 1
                      })) : _createCommentVNode("", true), _createVNode(_component_v_col, {
                        cols: _unref(features)?.customPricing ? 12 : 6
                      }, {
                        default: _withCtx(() => [_cache[12] || (_cache[12] = _createElementVNode("div", {
                          class: "text-subtitle-1 text-medium-emphasis"
                        }, " Payment ", -1)), _createVNode(_component_v_text_field, {
                          modelValue: upgradeState.subscriptions.paymentDescription,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => upgradeState.subscriptions.paymentDescription = $event),
                          variant: "solo-filled",
                          color: "primary",
                          disabled: true,
                          class: "tw green-input"
                        }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", {
                          class: "change-text ml-2",
                          onClick: _cache[4] || (_cache[4] = $event => changePaymentMethod('change'))
                        }, "Change")])]),
                        _: 1
                      }, 8, ["cols"])]),
                      _: 1
                    })]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_v_card_actions, {
                  class: "tw"
                }, {
                  default: _withCtx(() => [_createVNode(_component_v_spacer), _createVNode(LlSecondaryButton, {
                    onClick: closeDialog
                  }, {
                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("Cancel", -1)]))]),
                    _: 1
                  }), _createVNode(LlSecondaryButton, {
                    color: "primary",
                    onClick: confirmUpgrade
                  }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode(" Confirm ", -1)]))]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      });
    };
  }
};